export const MILLISECONDS_IN_HOUR = 1000 * 60 * 60;
export const TIME_AFTER_END_OF_LESSON = 10;
export const MINUTES_IN_DAY = 60 * 24;
